import { action, Action } from 'easy-peasy';
import { CardMenuType } from '@/types';

export interface IAdjustCollapseModel {
    destroy: Action<IAdjustCollapseModel>;
    /** 当前面板类型 */
    currentType: CardMenuType | '';
    /** 设置当前面板类型 */
    setCurrentType: Action<IAdjustCollapseModel, CardMenuType | ''>;
}

export const adjustCollapseModel: IAdjustCollapseModel = {
    destroy: action((state) => {
        state.currentType = '';
    }),
    currentType: '',
    setCurrentType: action((state, payload) => {
        state.currentType = payload;
    }),
};
